import styled from 'styled-components';
import { ReactComponent as Greater } from './greaterSign.svg';

const GreaterStyled = styled(Greater)`
    ${(props) => props.left && 'transform: rotate(180deg)'};
    ${(props) => props.disabled && 'fill: #ffffff;'}
`;

export default GreaterStyled;
